<div class="card">
  <div class="card-body" >
      <div style="display: flex; justify-content: center; align-items: center;">
        <mat-spinner *ngIf="!isLoaded"></mat-spinner>
      </div>
      <form [formGroup]="apiInfoForm" novalidate *ngIf="projectInfo">
          <!-- <mat-form-field style="width: 0;"> -->
              <!-- <input matInput hidden formControlName="id"> -->
          <!-- </mat-form-field> -->

          <div class="row">
            <div class="col-md-3">
              <mat-form-field class="example-full-width">
                  <input matInput type="text" placeholder="{{this.translate.data['TENANTNAME'] | translate}}" formControlName="tenantName" readonly>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field class="example-full-width">
                  <input matInput type="text" placeholder="{{this.translate.data['SQ3PROJECTID'] | translate}}" formControlName="sq3ProjId" readonly>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field class="example-full-width">
                  <input matInput type="text" placeholder="Projekt ID" formControlName="projectId" readonly>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field class="example-full-width">
                  <input matInput type="text" placeholder="{{this.translate.data['ENVIRONMENTID'] | translate}}" formControlName="environmentId" readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-md-3">
              <mat-form-field class="example-full-width">
              <input matInput type="text" placeholder="Backend Urls" formControlName="dummy" readonly>
            </mat-form-field>
            </div> -->
        <span style="font-size: 11px; margin-left: 16px;">Backend Urls</span>
          </div>
          <div class="row">
              <div style="width: 100%; max-height: 500px; overflow-y: auto;">
                <mat-option *ngFor="let item of projectInfo.backendUrls" [value]="item">
                  {{item}}
                </mat-option>
              </div>
              <!-- <div class="col-md-12">
                  <mat-form-field class="example-full-width">
                      <mat-label>Backend Urls</mat-label>
                      <mat-select formControlName="backendUrls">
                          <mat-option *ngFor="let item of projectInfo.backendUrls" [value]="item">
                              {{item}}
                          </mat-option>
                      </mat-select>
                  </mat-form-field>
              </div> -->
          </div>
      </form>
      <div class="row">
        <!-- <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px"  matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                            (click)="cancel()" >Abbruch</button>
        </a>                                                 -->
        <span style="flex: 1 1 auto"></span>
        <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="API Informationen zum Projekt in die Zwischenablage kopieren"
                                (click)="copy()" >Kopieren</button>
        </a>                   
      </div>    
</div>
</div>
